import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
  measurements: []
}


export default (state=initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        measurements: {
          $set: action.measurements
        }
    });
    case actionConsts.UPDATE_MEASUREMENT:
      return update(state, {
        measurements: {
          [action.index]: {
            [action.typeOf]: {
              $set: action.value
            }
          }
        }
    });
    case actionConsts.ADD_MEASSUREMENT:
      return update(state, {
        measurements: {
          $push: [action.measurement]
        }
    });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Measurements/reducer.js